module.exports = __webpack_public_path__ + "static/media/Image_UC1_Exerciser_Management_331_227@2X.f9ee541d.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/usecases/Image_UC1_Exerciser_Management_331_227@2X.png
// module id = 1268
// module chunks = 0